import type { FC } from 'react';
import { useCallback } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import type { SelectChangeEvent } from '@mui/material';
import { RedditPostsOrderBy } from '../types';
import type { SortBy } from '../types';

const SORT_BY_OPTIONS: { value: SortBy; label: string }[] = [
  { value: RedditPostsOrderBy.UpvotesCount, label: 'By upvotes' },
  { value: RedditPostsOrderBy.TrendScore, label: 'Trending fast' },
  { value: RedditPostsOrderBy.CommentsCount, label: 'By comments number' },
  { value: RedditPostsOrderBy.PostedAt, label: 'Newest first' },
];

interface TrendsSortByFilterProps {
  value: SortBy;
  onChange: (value: SortBy) => void;
}

const TrendsSortByFilter: FC<TrendsSortByFilterProps> = ({ value, onChange }) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent) => {
      onChange(event.target.value as SortBy);
    },
    [onChange]
  );

  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel id="trends-sort-by-label">Sort by</InputLabel>
      <Select
        labelId="trends-sort-by-label"
        id="trends-sort-by"
        label="Sort by"
        value={value}
        onChange={handleChange}
      >
        {SORT_BY_OPTIONS.map(({ value: optionValue, label }) => (
          <MenuItem key={optionValue} value={optionValue}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TrendsSortByFilter;
